const { h, render, Component } = require('preact');
const SingleActionSSAView = require('../../views/self_service_actions/single_action_ssa')
const Web2018Helper = require("../../../helper")

class OrderLevelSSA extends Component {
  constructor(props) {
    super(props);
    this.constructSSAs = this.constructSSAs.bind(this);
  }

  getEditOrderUrl(dealId, orderId){
    return `/deals/${dealId}/confirmation/${orderId}`
  }

  getRequestRefundUrl(orderId){
    return `/customer_support/web/refund_request?order_id=${orderId}`
  }

  constructEditOrderSSA(){
    if (this.props.orderDetails.id && lodash.has(this.props.orderDetails, 'deal.id')){
      return(
        {
          SSAText: I18n.translate("js.modules.support.edit_order"),
          UrlForSSA: this.getEditOrderUrl(this.props.orderDetails.deal.id, this.props.orderDetails.id)
        }
      );
    }
    return null;
  }

  constructCancelOrderSSA(){
    if (this.props.orderDetails.id && lodash.has(this.props.orderDetails, 'deal.id')){
      let baseUrl = `${this.getEditOrderUrl(this.props.orderDetails.deal.id, this.props.orderDetails.id)}#toggle-inputs`
      if(Web2018Helper.isFeatureFlagEnabled("enableRefundExtension"))
        baseUrl = `${this.getEditOrderUrl(this.props.orderDetails.deal.id, this.props.orderDetails.id)}?editable_types=cs_extended_refund#toggle-inputs`
      return(
        {
          SSAText: I18n.translate("js.modules.support.cancel_order"),
          UrlForSSA: baseUrl
        }
      );
    }
    return null;
  }

  constructTrackOrderSSA(){
    if (this.props.orderDetails.trackingUrl){
      return(
        {
          SSAText: I18n.translate("js.modules.support.track_order"),
          UrlForSSA: this.props.orderDetails.trackingUrl
        }
      );
    }
    return null;
  }

  constructUpdateShippingSSA(){
    if (this.props.orderDetails.id && lodash.has(this.props.orderDetails, 'deal.id')){
      return(
        {
          SSAText: I18n.translate("js.modules.support.update_shipping"),
          UrlForSSA: this.getEditOrderUrl(this.props.orderDetails.deal.id, this.props.orderDetails.id)
        }
      );
    }
    return null;
  }

  constructCancelReservationSSA(){
    if (this.props.orderDetails.id && lodash.has(this.props.orderDetails, 'deal.id')){
      return(
        {
          SSAText: I18n.translate("js.modules.support.cancel_reservation"),
          UrlForSSA: this.getEditOrderUrl(this.props.orderDetails.deal.id, this.props.orderDetails.id)
        }
      );
    }
    return null;
  }

  checkForRequestRefund(orderDetails) {
    return (orderDetails.id && lodash.has(orderDetails, 'deal.id')
            && orderDetails.metadata && orderDetails.metadata.isRefundEligible === true
            && ((Web2018Helper.isFeatureFlagEnabled("showSRT") && (orderDetails.groupons.length == 1)) ||
                (Web2018Helper.isFeatureFlagEnabled("showSRTForMultivoucherOrders") && (orderDetails.groupons.length > 1)))
          )
  }

  constructRequestRefundSSA(){
    let orderDetails = this.props.orderDetails
    if (this.checkForRequestRefund(orderDetails)) {
      return(
        {
          SSAText: I18n.translate("js.modules.support.refund_request"),
          UrlForSSA: this.getRequestRefundUrl(orderDetails.id)
        }
      );
    }
    return null;
  }

  getSSADetails(SSA){
    switch(SSA){
      case 'edit_order':
        return this.constructEditOrderSSA();
      case 'cancel_order':
        return this.constructCancelOrderSSA();
      case 'track_order':
        return this.constructTrackOrderSSA();
      case 'update_shipping':
        return this.constructUpdateShippingSSA();
      case 'cancel_reservations':
        return this.constructCancelReservationSSA();
      case 'refund_request':
        return this.constructRequestRefundSSA();
    }
  }

  constructSSAs() {
    let constructedSSAs = [];
    let SSADetails;
    this.props.SSAs.forEach(SSA => {
      SSADetails = this.getSSADetails(SSA);
      if (SSADetails)
      constructedSSAs.push(<SingleActionSSAView SSADetails={SSADetails} SSAType={SSA}/>)
    });
    return constructedSSAs;
  }

  render() {
    return (
      <div class="ssa">
        {this.constructSSAs()}
      </div>
    );
  }
}
module.exports = OrderLevelSSA
